<script>
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import DatePicker from "vue2-datepicker";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import ReadingWidget from "@/components/widgets/reading-widget.vue";
export default {
    name: "SubscriberReadingModal",
    components: {
        MaskedInput,
        DatePicker,
        ReadingWidget
    },
    props: {
        service: {
            type: Object,
            default: () => ({}),
        },
        menuType: {
            type: String,
            default: 'draft',
        },
    },
    data() {
        return {
            loading: false,
            readings: [],
            drafts: [],
            unpaid: [],
            loadDraft: false,
            subscriber: {},
            addNew: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            form: {
                id: 0,
                meterReading: '',
                remarks: '',
                readingDate: new Date(),
            },
            submitted: false,
            filter: 1,
            fromDate: new Date(),  
            toDate: new Date(),
            readType: 1,
            meterReadingError: false,
        };
    },
    validations: {
        form: {
            meterReading: { required },
            readingDate: { required },
        },
    },
    methods: {
        async getData(subscriber, type){
            this.subscriber = subscriber;
            this.loading = true;
            this.loadDraft = true;
            this.readings = [];
            await this.getSubscriberData(subscriber);
            this.loading = false;
            if(type){
                this.readType = type;
                this.changeReadType(type);
            }else{
                await this.getDrafts(subscriber);
            }
            this.loadDraft = false;
        },
        async changeFilter(subscriber){
            this.loading = true;
            this.readings = [];
            await this.getSubscriberData(subscriber);
            this.loading = false;
        },
        async getDrafts(subscriber){
            if(this.drafts.length) return;
            await this.$store
                .dispatch("subscribermeterreading/GetDraftSubscriberMeterReading", subscriber.id)
                .then((response) => {
                    if(response.data.error){
                        return this.showToast(response.data.errorMessage, 'error')
                    }
                    this.drafts = response.data;
                })
                .catch((error) => {
                    this.showToast('Something went wrong', 'error')
                });
        },
        async getSubscriberData(subscriber){
            if(this.filter == 1){
                await this.$store
                    .dispatch("subscribermeterreading/GetLatestSubscriberMeterReading", subscriber.id)
                    .then((response) => {
                        if(response.data.error){
                            return this.showToast(response.data.errorMessage, 'error')
                        }
                        this.readings = response.data ? [response.data] : [];
                    })
                    .catch((error) => {
                        this.showToast('Something went wrong', 'error')
                    });
            }else if(this.filter == 2){
                await this.$store
                    .dispatch("subscribermeterreading/GetRangeSubscriberMeterReading", {
                        id: subscriber.id,
                        dateFrom: this.getDate(new Date(this.fromDate).setHours(0,0,0,0)),
                        dateTo: this.getDate(new Date(this.toDate).setHours(23,59,59,999)),
                        removeLoading: true
                    })
                    .then((response) => {
                        if(response.data.error){
                            return this.showToast(response.data.errorMessage, 'error')
                        }
                        this.readings = response.data.sort((a, b) => {
                            return new Date(b.readingDate) - new Date(a.readingDate);
                        });
                    })
                    .catch((error) => {
                        this.showToast('Something went wrong', 'error')
                    });
            }else {
                await this.$store
                    .dispatch("subscribermeterreading/GetAllSubscriberMeterReading", subscriber.id)
                    .then((response) => {
                        if(response.data.error){
                            return this.showToast(response.data.errorMessage, 'error')
                        }
                        this.readings = response.data.sort((a, b) => {
                            return new Date(b.readingDate) - new Date(a.readingDate);
                        });
                    })
                    .catch((error) => {
                        this.showToast('Something went wrong', 'error')
                    });
            }
        },
        async onResetForm(){
            this.form = {
                id: 0,
                meterReading: '',
                remarks: '',
                readingDate: new Date(),
            };
            this.submitted = false;
        },
        getPreviousReading(){
            if(!this.readings.length){
                return '';
            }
            let reading = this.readings[0].meterReading ? this.formatNumber(this.readings[0].meterReading) : '';
            return reading;
        },
        async addReading(){
            this.addNew = true;
            this.meterReadingError = false;
            this.submitted = false;
            this.onResetForm();
            this.form.meterReading = this.getPreviousReading();
            await this.wait(200);
            this.$refs.inputReading.$el.focus();
        },
        async saveReading(){
            this.submitted = true;
            this.$v.form.$touch();
            if(this.$v.form.$invalid) return;
            if(this.getPreviousReading() != ''){
                if(parseFloat(this.getExactAmt(this.form.meterReading)) < parseFloat(this.getExactAmt(this.getPreviousReading()))){
                    return this.meterReadingError = true;
                }
            }
            let data = cloneDeep(this.form);
            data.meterReading = this.getExactAmt(this.form.meterReading);
            data.readingDate = this.getDate(this.form.readingDate);
            data.subscriberId = this.subscriber.id;
            if(this.form.id > 0){
                await this.$store
                    .dispatch("subscribermeterreading/UpdateSubscriberMeterReading", data)
                    .then((response) => {
                        if(response.data.error){
                            return this.showToast(response.data.errorMessage, 'error')
                        }
                        let index = this.drafts.findIndex(x => x.id == data.id);
                        this.drafts.splice(index, 1, data);  
                        this.addNew = false;
                        this.showToast('Successfully updated new reading', 'success')
                    })
                    .catch((error) => {
                        this.showToast('Something went wrong', 'error')
                    });
            }else{
                if(this.drafts.length){
                    return this.showToast('You cannot add new reading, please post the draft first', 'warning')
                }
                await this.$store
                    .dispatch("subscribermeterreading/AddSubscriberMeterReading", data)
                    .then((response) => {
                        if(response.data.error){
                            return this.showToast(response.data.errorMessage, 'error')
                        }
                        this.addNew = false;
                        if(response.data.isPosted && !this.readings.length){
                            this.readings.push(response.data);
                        }
                        if(response.data.isPosted && this.readings.length){
                            if(this.filter == 1){
                                this.readings.splice(0, 1, response.data);
                            }else{
                                this.readings.unshift(response.data);
                            }
                        }
                        if(!response.data.isPosted){
                            this.drafts.unshift(response.data);
                        }
                        this.showToast('Successfully added new reading', 'success')
                    })
                    .catch((error) => {
                        this.showToast('Something went wrong', 'error')
                    });
            }
        },
        async updateReading(reading){
            this.addNew = true;
            await this.wait(300);
            this.form = cloneDeep(reading);
            this.form.meterReading = this.formatNumber(reading.meterReading);
            this.form.readingDate = new Date(reading.readingDate);
            this.$refs.inputReading.$el.focus();
        },
        async deleteReading(reading){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch("subscribermeterreading/RemoveSubscriberMeterReading", reading.id)
                        .then(async (response) => {
                            if(response.data.error){
                                return this.showToast(response.data.errorMessage, 'error')
                            }
                            this.showToast('Successfully deleted reading', 'success')
                            if(this.filter == 1){
                                await this.getSubscriberData(this.subscriber);
                            }
                            this.drafts = [];
                            this.changeReadType(this.readType);
                        })
                        .catch((error) => {
                            this.showToast('Something went wrong', 'error')
                        });
                }
            });
        },
        printReading(reading){
            this.$emit("printReading", reading);
        },
        async postReading(reading){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch("subscribermeterreading/PostSubscriberMeterReading", reading.id)
                        .then((response) => {
                            if(response.data.error){
                                return this.showToast(response.data.errorMessage, 'error')
                            }
                            if(!this.readings.length){
                                this.readings.push(reading);
                            }else{
                                if(this.filter == 1){
                                    this.readings.splice(0, 1, reading);
                                }else{
                                    this.readings.unshift(reading);
                                }
                            }
                            let index = this.drafts.findIndex(x => x.id == reading.id);
                            this.drafts.splice(index, 1);  
                            this.showToast('Successfully posted reading', 'success')
                        })
                        .catch((error) => {
                            this.showToast('Something went wrong', 'error')
                        });
                }
            });
        },
        async getUnpaid(subscriber){
            await this.$store
                .dispatch("subscribermeterreading/GetUnpaidSubscriberMeterReading", subscriber.id)
                .then((response) => {
                    if(response.data.error){
                        return this.showToast(response.data.errorMessage, 'error')
                    }
                    this.unpaid = response.data;
                })
                .catch((error) => {
                    this.showToast('Something went wrong', 'error')
                });
        },
        async changeReadType(type){
            this.loadDraft = true;
            if(type == 1){
                await this.getDrafts(this.subscriber);
            }else{
                await this.getUnpaid(this.subscriber);
            }
            this.loadDraft = false;
        }
    }
}
</script>
<template>
    <div class="row">
        <div class="col-md-4 border-end" v-if="menuType == 'draft'">
            <p class="text-orange font-weight-bold font-size-15 mb-3">Previous Reading: <span v-if="readings.length">{{getPreviousReading()}}</span></p>
            <div class="text-right mb-3">
                <div class="border py-5 d-flex justify-content-center align-items-center cursor-pointer border-primary rounded" v-if="!addNew"  @click="addReading">
                    <p class="mb-0 text-purple font-size-18"><i class="bx bx-plus"></i>  Add New Reading</p>
                </div>
            </div>
            <div class="reading-item mb-3" v-if="addNew">
                <form @submit.prevent="saveReading">
                    <div class="buttons d-flex gap-1">
                        <button type="submit" class="btn btn-sm btn-success" v-if="addNew">
                            <i class="bx bx-check"></i> Save
                        </button>
                        <button type="button" class="btn btn-sm btn-warning" @click="addNew = false" v-if="addNew">
                            <i class="bx bx-x"></i> Cancel
                        </button>
                    </div>
                    <div class="d-flex align-items-center">
                        <p class="mb-0">Reading Date: </p>
                        <date-picker
                            v-model="form.readingDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Reading Date..."
                            class="form-control-sm custom-date-picker"
                            format="MMMM DD, YYYY"
                            :class="{
                                'is-invalid': submitted && $v.form.readingDate.$error,
                            }"
                        >
                        </date-picker>
                    </div>
                    <div class="reading mb-1">
                        <masked-input 
                            autocomplete="off"
                            type="text"
                            ref="inputReading"
                            v-model="form.meterReading"
                            placeholder="Input Reading"
                            class="form-control input-reading text-white"
                            :class="{
                                'is-invalid': submitted && ($v.form.meterReading.$error || meterReadingError),
                            }"
                            :mask="currencyMask"
                        ></masked-input>
                        <div class="invalid-feedback" v-if="submitted && meterReadingError">
                            Reading must be greater than previous reading.
                        </div>
                    </div>
                    <div class="remarks text-secondary" >
                        <input class="form-control text-right form-control-sm" placeholder="Remarks" v-model="form.remarks"/>
                    </div>
                </form>
            </div>
        </div>
        <div class="border-end" :class="{
            'col-md-4': menuType == 'draft',
            'col-md-6': menuType == 'unpaid',
        }">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <select class="form-select form-select-sm me-3" style="width:100px;" v-model="filter" @change="changeFilter(subscriber)">
                    <option value="1">Latest</option>
                    <option value="2">Range</option>
                </select>
                <div class="d-flex align-items-center" v-if="filter == 2">
                    <p class="mb-0 me-1">From</p>
                    <date-picker
                        v-model="fromDate"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="From Date..."
                        @change="changeFilter(subscriber)"
                        class="form-control-sm"
                    >
                    </date-picker>
                    <p class="mb-0 mx-2">To</p>
                    <date-picker
                        v-model="toDate"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="From Date..."
                        @change="changeFilter(subscriber)"
                        class="form-control-sm"
                    >
                    </date-picker>
                </div>
            </div>
            <div  class="reading-item d-flex align-items-center justify-content-center py-5" v-if="loading">
                <div>Loading...</div>
            </div>
            <div  class="reading-item d-flex align-items-center justify-content-center py-5" v-if="readings.length == 0 && !loading">
                <div>No previous reading.</div>
            </div>
            <template v-if="!loading && readings.length">
                <ReadingWidget 
                    :tableData="readings"
                    :service="service"
                    @printReading="printReading"
                />
            </template>
        </div>
        <div :class="{
                'col-md-4': menuType == 'draft',
                'col-md-6': menuType == 'unpaid',
            }"
        >
            <div class="d-flex justify-content-between align-items-center mb-3">
                <p class="mb-0 font-size-15 mt-1 font-weight-bold text-white">List of {{readType == 1 ? 'draft' : 'unpaid'}} meter reading</p>
                <div class="d-flex align-items-center">
                    <div class="d-flex">
                        <div class="pill-item" :class="{'active': readType == 1}" @click="readType = 1; changeReadType(1)">
                            Draft
                        </div>
                        <div class="pill-item" :class="{'active text-orange': readType == 2}" @click="readType = 2; changeReadType(2)">
                            Unpaid
                        </div>
                    </div>
                </div>
            </div>
            <div  class="reading-item d-flex align-items-center justify-content-center py-5" v-if="loadDraft">
                <div>Loading...</div>
            </div>
            <div  class="reading-item d-flex align-items-center justify-content-center py-5" v-if="(readType == 2 && !unpaid.length && !loadDraft) || (readType == 1 && !drafts.length && !loadDraft) ">
                <div>No {{readType == 1 ? 'draft' : 'unpaid'}} reading created.</div>
            </div>
            <template v-if="readType == 1 && !loadDraft && drafts.length">
                <ReadingWidget 
                    :tableData="drafts"
                    :withButtons="menuType === 'draft'"
                    :service="service"
                    @postReading="postReading($event)"
                    @updateReading="updateReading($event)"
                    @deleteReading="deleteReading($event)"
                    @printReading="printReading"
                />
            </template>
            <template v-if="readType == 2 && !loadDraft && unpaid.length">
                <ReadingWidget 
                    :tableData="unpaid"
                    :service="service"
                    @printReading="printReading"
                />
            </template>
        </div>
    </div>
</template>
<style lang="scss">
.custom-date-picker{
    width: 150px !important;
    input{
        border: none !important;
        outline: none !important;
        font-weight: bold !important;
        color: rgb(var(--bs-white-rgb)) !important;
        font-size: 20px;
    }
    .mx-icon-calendar{
        display: none !important;
    }
}
.reading-item {
    position: relative;
    border: 1px solid var(--bs-gray-300);
    padding: 10px;
    border-radius: 10px;

    .buttons{
        position: absolute;
        top: -10px;
        right: 0;
        z-index: 1;
    }
    .label{
        font-size: 15px;
        position: absolute;
        top: -10px;
        background: var(--bs-body-bg);
        padding-inline: 8px;
    }
    .reading{
        font-size: 30px;
        font-weight: bold;
        text-align: right;
    }

    .remarks{
        font-size: 12px;
        text-align: right;
    }

    .input-reading{
        font-size: 30px;
        font-weight: bold;
        color: rgb(var(--bs-black-rgb));
        text-align: right;
        background: var(--bs-gray-200);
        border: none;
        border-radius: 5px;
        &.form-control.is-invalid{
            padding-right: 10px !important;
        }
    }
    .invalid-feedback{
        font-size: 12px;
        font-weight: bold;
        color: var(--bs-danger);
    }
}
.pill-item{
    background: var(--bs-gray-200);
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 12px;
    margin-right: 5px;
    color: var(--bs-gray-600);
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    &:hover{
        background: var(--bs-gray-300);
        color: var(--bs-gray-800);
    }
    &.active{
        background: var(--bs-gray-300);
        color: var(--bs-white);
    }
}
</style>